module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/U5NUMe/tc-custom/9781035852970.jpg?1721057580440",
      "alt": "This image is the cover for the book Things Love Can't Teach You"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Things Love Can't Teach You\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Key, an everyman, finds his life upended when he relocates to New York, a city he never favored. Following a break-up with his long-term girlfriend, Key’s life seems to spiral downwards. In the chaos of New York, he repeatedly crosses paths with Slate, a successful businessman known for his numerous lovers. Initially, Slate sees Key as a mere annoyance, a country boy obstructing his path. However, as Slate involves Key in his business affairs, he becomes unexpectedly charmed by Key’s allure, despite their frequent clashes. As their lives intertwine, Key and Slate are drawn to each other, leading to an unexpected romance. But looming over their newfound connection is the uncertainty of its future.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jenifer Angelo\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0